import {
  FETCH_STONE_SIZE_REQUEST,
  FETCH_STONE_SIZE_SUCCESS,
  FETCH_STONE_SIZE_FAILURE,
  ADD_STONE_SIZE_REQUEST,
  ADD_STONE_SIZE_SUCCESS,
  ADD_STONE_SIZE_FAILURE,
  UPDATE_STONE_SIZE_REQUEST,
  UPDATE_STONE_SIZE_SUCCESS,
  UPDATE_STONE_SIZE_FAILURE,
  DELETE_STONE_SIZE_REQUEST,
  DELETE_STONE_SIZE_SUCCESS,
  DELETE_STONE_SIZE_FAILURE,
  STONE_SIZE_FORM_ERROR,
  STONE_SIZE_FORM_SUCCESS,
  SET_STONE_SIZE_EDIT,
  CLEAR_STONE_SIZE_EDIT,
} from '../../../../types/masters/stoneAttribute/stoneSize/stoneSizeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingStoneSize: null,
};

const stoneSizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONE_SIZE_REQUEST:
    case ADD_STONE_SIZE_REQUEST:
    case UPDATE_STONE_SIZE_REQUEST:
    case DELETE_STONE_SIZE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STONE_SIZE_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_STONE_SIZE_SUCCESS:
    case UPDATE_STONE_SIZE_SUCCESS:
    case DELETE_STONE_SIZE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_STONE_SIZE_FAILURE:
    case ADD_STONE_SIZE_FAILURE:
    case UPDATE_STONE_SIZE_FAILURE:
    case DELETE_STONE_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case STONE_SIZE_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case STONE_SIZE_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_STONE_SIZE_EDIT:
      return { ...state, editingStoneSize: action.payload };
    case CLEAR_STONE_SIZE_EDIT:
      return { ...state, editingStoneSize: null };
    default:
      return state;
  }
};

export default stoneSizeReducer; 